// extracted by mini-css-extract-plugin
module.exports = {"centering":"centering__centering2Ny","centering--less-bottom-margin":"centering__centering--less-bottom-margin28P","relative":"centering__relative1Ce"};